<template>
<div class="styled-radio styled-radio--ou-donation row">
  <div v-for="amount of amounts" :key="amount" class="radio-part" :data-amount="amount" :id="amount">
      <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
      <FormLabel :for="`amount${amount}`" :data-amount="amount" :class="{'fave__amt__label': (isMonthly && amount === 36) || (!isMonthly && amount === 108)}">
        <img src="https://res.cloudinary.com/orthodox-union/image/upload/w_25/v1749469110/heart-icon_hcjyd8.png" alt="fave amt" class="fave_amt" v-if="(isMonthly && amount === 36) || (!isMonthly && amount === 108)"/>
		    <span class="label-title" v-if="isMonthly && monthlyTitles[amount]">{{ monthlyTitles[amount] }}</span>
        <span v-if="tierDescriptions && descriptions[amount]" class="label-description" v-html="descriptions[amount]"></span>
        <MoneyFormat v-else class="label-amount" :value="amount" :currencyCode="form.currency || 'USD'" :hide-subunits="subunits" />
	  </FormLabel>
  </div>
  
  <div class="radio-part" v-if="includeOther" :class="form.currency">
      <input id="amount_other_field" type="number" min="1" name="amount_other" :placeholder="amountText" v-model="customAmount" />
  </div>

  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

import { queryParams } from '~/shared/query-params'
import { initialAmountSources } from '~/shared/initial-amounts'
import MoneyFormat from '~/components/MoneyFormat.vue'

export default defineComponent({
  components: {
    MoneyFormat
  },
  props: {
    subunits: {
      type: Boolean,
      default: true
    },
    includeOther: {
      type: Boolean,
      default: true
    },
    defaultCheckedAount:{
      type: String
    },
    amountText:{
      type: String,
      default: "Enter amount",
    },
    monthlyTiers: {
      type: Boolean,
      default: true
    },
    hideButtons: {
      type: Boolean,
      default: false
    },
    // render the label of [amount, label] tuples instead of the amount
    tierDescriptions: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()

    const monthlyTitles: Record<number, string> = {
      10: 'Alumni',
      18: 'Chai Circle',
      36: 'Friend of NCSY',
      100: 'Builder of the Future',
      360: 'Leadership Circle',
      1000: 'Am Yisrael Benefactor',
    }
    const customAmount = ref(form.value.amount)

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customAmount.value = null

        setValue('amount', '' + selectedAmount)
      }
    })

    watch(customAmount, (customAmount) => {
      if (customAmount) selectedAmount.value = null

      if (!selectedAmount.value) setValue('amount', customAmount || null)
    })

    const isMonthly = computed(() => props.monthlyTiers && !!form.value.dayOfMonth)

    const amounts = computed(() => {
      if (props.hideButtons) return []

      if (isMonthly.value) {
        // Return monthly amounts
        return [1000, 360, 100, 36, 18, 10]
      }
      
      return amountTiers.value.map(([amount]) => amount)
    })

    // settings.amounts as [amount, label] pairs; plain numbers get an empty label
    const amountTiers = computed<[number, string][]>(() => {
      const currency = form.value.currency || 'USD'
      const amounts = settings!.amounts!
      const list: unknown[] = Array.isArray(amounts) ? amounts : (amounts[currency] ?? [])

      return list.map((entry: any) => {
        if (!Array.isArray(entry)) return [entry, '']
        const [value, label] = entry
        return [typeof value === 'number' ? value : value[currency], label]
      })
    })

    const descriptions = computed(() => Object.fromEntries(amountTiers.value))

    const params = queryParams()

    for (const amount of initialAmountSources(form.value.amount, params.amount, props.defaultCheckedAount)) {
      //@ts-ignore
      if (amounts.value.includes(+amount)) {
        selectedAmount.value = amount
        customAmount.value = null
      }
      else {
        customAmount.value = amount
      }
    }

    return {
      form,
      amounts,
      descriptions,
      selectedAmount,
      customAmount,
      monthlyTitles,
      isMonthly,
    }
  },
})
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation  .amount_other__wrapper{
    position: relative;
    margin-bottom: 0px;
    background: rgba(255, 255, 255, 0.05);
    overflow: hidden;
    // border: 1px solid #ddd;
    border-radius: 6px;
    padding: 5px 16px;
    flex: 1;
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 12px;

    span{
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #96999C;
      vertical-align: middle;

    }
    @media (max-width: 1020px) {
      gap:2px;
      padding: 0px;
       
        span{
          display: none;
        }
        #amount_other_check{
          display: none;
        }
    }

        @media (max-width: 960px) {
        width: calc((100% - 44px) / 3);
        min-width: calc((100% - 44px) / 3);
        max-width: calc((100% - 44px) / 3);
        }
   
    input[type='number'] {
          background: rgba(255, 255, 255, 0.1);
    border: 1px solid #595C5F;
    border-radius: 6px;
    color: #96999C;
    height: 38px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    padding: 9px 12px;
    width: 100%;

    &:focus {
    border-color: #15329d;
    box-shadow: none;
    color: #222;
    background: white;
    box-shadow: 0 0 3px rgba(56, 93, 163, 0.5);
    }
    //   border: none;
    //   margin-left: 20px;
    //   box-shadow: none;
    //   width: calc(100% + 20px);
    //   font-size: 12px;
    
    }
    &:after {
      display: none !important;
    }
  }
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
              @media only screen and (max-width: 720px) {
              gap: 8px;
              }
  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
        width: calc((100% - 44px) / 3);
        padding: 0px;
    }
    @media (min-width: 720px) {
      flex: 1;
           min-width: calc((100% - 16px) / 3);
           max-width: calc((100% - 16px) / 3);
      padding-right: 0px;
      padding-left: 0;
      margin-bottom: 0px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }

    input#amount_other_field{
      display: flex;
height: 40px;
padding: 8px 12px;
align-items: center;
gap: 8px;
flex-shrink: 0;
align-self: stretch;
border-radius: 100px;
border: 1.2px solid var(--Grayscale-Input, #EBEBEB);
background: var(--Grayscale-Off-white, #FCFCFC);
color: var(--Grayscale-Placehold, #9C9697);
text-align: center;
    box-shadow: none;
/* Desktop/Text/Placeholder */
max-width: 100%;
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 300;
line-height: 24px; /* 171.429% */

      &:focus,
      &:active {
        color: #000;
      }
    }
  }
  input[type='radio'] {
    height: 0px;
    display: none;
    top: 0px;
    position: absolute;
    left:0px;
    z-index: -1;
    visibility: hidden;
  }
  label {
display: flex;
min-height: 48px;
    position: relative;
padding: 12px;
justify-content: center;
align-items: center;
flex-flow: column;
gap: 2px;
flex: 1 0 0;
border-radius: 100px;
border: 1px solid var(--Grayscale-Ash, #160D10);
color: var(--Grayscale-Ash, #160D10);
text-align: center;
cursor: pointer;
/* Desktop/Text/Link - Regular */
font-family: "Albert Sans";
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 142.857% */
    @media only screen and (max-width: 720px) {
      
    }

    &.fave__amt__label{
        .money_format.label-amount {
        }
    }
    .money_format.label-amount {
    // font-style: normal;
    // font-weight: 500;
    // font-size: 16px;
    // line-height: 24px;
    // display: flex;
    // align-items: center;
    // color: #1E50B4;

    //     @media only screen and (max-width: 720px) {
    //     font-size: 14px;
    //     line-height: 20px;
    // }

    &:hover{
            // background: #EBEBEB;
    }
}
  }
  input[type='radio']:checked + label {
background: rgba(22, 13, 16, 0.12);
color: var(--Grayscale-Ash, #160D10);
font-weight: 600;
    &.fave__amt__label{
        img{
            opacity: 1;
        }
        .money_format.label-amount {
        // color: white;
        }
    }
    .money_format.label-amount {
        // color: white;
    }
  

  }
  label:hover {
background: rgba(22, 13, 16, 0.12);
color: var(--Grayscale-Ash, #160D10);
font-weight: 600;

  }
  .amount_other__wrapper {
    input[type='number'] {

    }
  }
}  

.donateion__list {
    max-width: 508px;
    margin: auto;
}

.most__impactful{
    position: absolute;
    top: 37%;
    right: 128px;
        @media only screen and (max-width: 720px) {
     display: none;
    }
}
.most__impactful--mobile{
      position: absolute;
    top: 27%;
    right: 0px;
        @media only screen and (min-width: 720px) {
     display: none;
    }
}
.radio-part.USD {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
}

.label-title{
  color: var(--Grayscale-Ash, #160D10);
    text-align: center;
  font-family: 'Albert Sans';
  font-size: 12px;
}
img.fave_amt {
    position: absolute;
    left: 13px;
    bottom: 5px;
    opacity: 0.6;
        line-height: normal;
}
</style>